import { render, staticRenderFns } from "./bayWindow.vue?vue&type=template&id=1f742c50&scoped=true"
import script from "./bayWindow.vue?vue&type=script&lang=js"
export * from "./bayWindow.vue?vue&type=script&lang=js"
import style0 from "./bayWindow.vue?vue&type=style&index=0&id=1f742c50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f742c50",
  null
  
)

export default component.exports